const NOMS = [
  {
    code: "逆风者",
    badge: "提名指数 96",
    img: "https://readdy.ai/api/search-image?query=shadowed%20figure%20rising%20against%20wind%20with%20cream%20smoke%20and%20ink%20texture%2C%20editorial%20news%20magazine%20photo%2C%20dramatic%20single%20red%20accent%20light%2C%20minimal%20dark%20studio%20backdrop%2C%20artistic%20high%20contrast&width=560&height=520&seq=nomi-wind-03&orientation=squarish"
    ,
    reason: "「越被唱衰越被关注」的完整翻盘叙事已成型，舆论三次唱衰反而三次助燃。",
    doubt: "争议素材高度同质，被指全靠情绪撑场。",
    note: "最接近下一位人选的领跑者",
  },
  {
    code: "深水区",
    badge: "提名指数 89",
    img: "https://readdy.ai/api/search-image?query=dark%20deep%20water%20abstraction%20with%20hidden%20layers%20and%20cream%20paper%20texture%2C%20editorial%20mystery%20magazine%20art%2C%20subtle%20red%20glow%2C%20minimal%20noir%20graphic%2C%20layered%20vintage%20print%20composition&width=560&height=520&seq=nomi-deep-04&orientation=squarish"
    ,
    reason: "数份「旧账底稿」被逐一翻译，变量最充足，随时可引爆。",
    doubt: "底稿来源与真伪仍待交叉印证。",
    note: "本周上升最快的变量型选手",
  },
  {
    code: "临界点",
    badge: "提名指数 81",
    img: "https://readdy.ai/api/search-image?query=sharp%20geometric%20horizon%20line%20breaking%20into%20light%2C%20cream%20background%20with%20ink%20shadow%20play%2C%20editorial%20concept%20photography%2C%20minimal%20red%20and%20black%20contrast%2C%20artistic%20magazine%20graphic&width=560&height=520&seq=nomi-line-05&orientation=squarish"
    ,
    reason: "结束三个月隐身，本周连续两条高能动态，争夺盘口剧烈波动。",
    doubt: "久未营业，围观惯性能否延续待观察。",
    note: "回归型选手，盘口波动源",
  },
  {
    code: "回声室",
    badge: "提名指数 74",
    img: "https://readdy.ai/api/search-image?query=repeated%20echoing%20soundwave%20ripples%20in%20cream%20paper%20with%20ink%20concentric%20rings%2C%20editorial%20abstract%20magazine%20art%2C%20warm%20red%20accent%2C%20minimal%20graphic%20design%20print&width=560&height=520&seq=nomi-echo-06&orientation=squarish"
    ,
    reason: "一条旧录音被重新翻译，带动单周热度上升九位。",
    doubt: "话题依赖单一素材，延展性弱。",
    note: "本周榜单最大跳升",
  },
  {
    code: "风向标",
    badge: "提名指数 68",
    img: "https://readdy.ai/api/search-image?query=calibrated%20wind%20vane%20instrument%20on%20cream%20background%2C%20editorial%20vintage%20magazine%20still%20life%2C%20ink%20sketch%20texture%2C%20muted%20red%20detail%2C%20artistic%20print%20composition&width=560&height=520&seq=nomi-vane-07&orientation=squarish"
    ,
    reason: "热评三连引发密集围观，讨论快速从「是谁」滑向「凭什么」。",
    doubt: "被质疑「自我造浪」，真实性存疑。",
    note: "热度快但存在自我驱动嫌疑",
  },
  {
    code: "万花筒",
    badge: "提名指数 60",
    img: "https://readdy.ai/api/search-image?query=colorful%20kaleidoscope%20fragments%20arranged%20in%20cream%20paper%20collage%2C%20editorial%20abstract%20magazine%20art%2C%20many%20small%20diverse%20elements%2C%20ink%20frame%2C%20subtle%20red%20pop%20graphic&width=560&height=520&seq=nomi-kale-08&orientation=squarish"
    ,
    reason: "多次进入提名人选视野，围观习惯稳定。",
    doubt: "素材碎片化、指向分散，难聚成主线。",
    note: "常驻提名，难登顶",
  },
];

export default function Nominations() {
  return (
    <section id="nomi" className="border-t border-[#e4d9c6] bg-[#f6f0e6]">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] text-[#b03a2e] uppercase">
              Nomination Files
            </p>
            <h2 className="font-display mt-2 text-2xl font-black text-[#18130e] md:text-4xl">
              下一位候选人提名盘点
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-[#6b5a48]">
            六位候选人档案，逐一列出提名理由与存疑点——谁在攒票，谁在自证，谁只是过客。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {NOMS.map((n) => (
            <article
              key={n.code}
              className="group flex flex-col overflow-hidden rounded-xl border border-[#e4d9c6] bg-[#fbf7ef] transition-colors hover:border-[#b03a2e]"
            >
              <div className="relative h-52 overflow-hidden md:h-56">
                <img
                  src={n.img}
                  alt={`${n.code} 黑料王候选人提名档案`}
                  title={`黑料王候选人 ${n.code} 提名盘点`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-[#b03a2e] px-3 py-1 text-[11px] font-bold text-[#fbf7ef]">
                  {n.badge}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <h3 className="font-display text-xl font-bold text-[#18130e]">{n.code}</h3>
                  <span className="text-xs text-[#b03a2e]">· {n.note}</span>
                </div>
                <dl className="mt-3 space-y-2 text-sm">
                  <div className="flex gap-2">
                    <dt className="shrink-0 font-semibold text-[#8f2a20]">提名理由</dt>
                    <dd className="leading-relaxed text-[#4a4036]">{n.reason}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="shrink-0 font-semibold text-[#8a6b4f]">存疑点</dt>
                    <dd className="leading-relaxed text-[#6b5a48]">{n.doubt}</dd>
                  </div>
                </dl>
                <button
                  type="button"
                  className="mt-auto flex w-full cursor-pointer items-center justify-between whitespace-nowrap rounded-md border border-[#d9cbb2] px-4 py-2 pt-2 text-sm font-medium text-[#18130e] transition-colors hover:border-[#b03a2e] hover:text-[#8f2a20] sm:mt-5"
                >
                  查看完整档案
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}